import type { EditorSettings } from '../../../settings/EditorSettings';

export interface SessionOptions {
  pythonVersion?: string;
  pythonPlatform?: string;
  pyrightVersion?: string;
  typeCheckingMode?: string;
  locale?: string;
  include?: string[];
  exclude?: string[];
  extraPaths?: string[];
  useLibraryCodeForTypes?: boolean;
  reportMissingImports?: boolean;
  reportMissingTypeStubs?: boolean;
  reportWildcardImportFromLibrary?: boolean;
}

export const DEFAULT_LSP_SESSION_OPTIONS: EditorSettings = {
  typeCheckingMode: 'basic',
  exclude: ['**/node_modules', '**/__pycache__'],
  useLibraryCodeForTypes: true,
  reportMissingImports: true,
  reportMissingTypeStubs: true,
  reportWildcardImportFromLibrary: false,
};
